<div class="d-flex">
    <div class="mb-4 w-100">
        <app-about-me-contact-information></app-about-me-contact-information>
    </div>
</div>

<p-panel [toggleable]="true">
    <ng-template pTemplate="header">
        <fa-icon [icon]='["far","store-alt"]' class="mx-2"></fa-icon>
        <div class="h4">
            My restaurants
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <app-about-me-venues></app-about-me-venues>
    </ng-template>
</p-panel>

<p-panel [toggleable]="true" [collapsed]="true">
    <ng-template pTemplate="header">
        <fa-icon [icon]='["far","gift-card"]' class="mx-2"></fa-icon>
        <div class="h4">
            Gift Cards
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <app-about-me-egift-purchases></app-about-me-egift-purchases>
        <app-about-me-egift-received></app-about-me-egift-received>
    </ng-template>
</p-panel>

<p-panel [toggleable]="true" [collapsed]="true">
    <ng-template pTemplate="header">
        <fa-icon [icon]='["far","hand-holding-box"]' class="mx-2"></fa-icon>
        <div class="h4">
            Subscriptions
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <app-about-me-subscriptions></app-about-me-subscriptions>
    </ng-template>
</p-panel>

<p-panel [toggleable]="true" [collapsed]="true">
    <ng-template pTemplate="header">
        <fa-icon [icon]='["far","credit-card-front"]' class="mx-2"></fa-icon>
        <div class="h4">
            Payment methods
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <app-about-me-payment-methods></app-about-me-payment-methods>
    </ng-template>
</p-panel>

<p-divider></p-divider>
<div class="d-flex my-2 w-100">
    <div class="mx-auto">
        <p-button pRipple styleClass="p-button-raised p-button-info" (click)="customerKeyChange.emit(undefined);">
            <ng-template pTemplate="content">
                <div class="d-flex justify-content-center">
                    <fa-icon [icon]='["far","sign-out-alt"]' size="lg" class="ms-1 me-2"></fa-icon>
                    Sign out
                </div>
            </ng-template>
        </p-button>
    </div>
    
</div>
